<div class="container">
  <div>
    <div class="caption" (click)="onTap()">{{ "login.title" | translate }}</div>
    <div class="subcaption">
      {{ "login.version" | translate : { version: state.version } }}
    </div>
    <br />
    <ion-input
      [label]="'common.username' | translate"
      labelPlacement="floating"
      fill="outline"
      [(ngModel)]="username"
      mode="md"
    ></ion-input>
    <br />
    <ion-input
      [label]="'common.password' | translate"
      labelPlacement="floating"
      fill="outline"
      mode="md"
      type="password"
      (keyup.enter)="login()"
      [(ngModel)]="password"
      ><ion-input-password-toggle slot="end"></ion-input-password-toggle
    ></ion-input>
    <br />
    <!--ion-checkbox
      [(ngModel)]="stayLoggedIn"
      labelPlacement="end"
      style="margin-left: 2px"
      >Angemeldet bleiben</ion-checkbox
      -->

    <ion-button
      style="width: 100%"
      (click)="login()"
      [disabled]="password == null || username == null"
      >{{ "login.submit" | translate }}</ion-button
    >

    <div class="error">{{ errorMessage }}</div>
  </div>
</div>
